import isEmpty from 'lodash/isEmpty';

export function checkIfUrlPointsToExtraRewards(url, extraRewardsPage) {
  return !isEmpty(url) && !isEmpty(extraRewardsPage) && url.indexOf(extraRewardsPage) > -1;
}
